jQuery(function ($) {

  $('.hamburger').on('click', function() {
    $(this).toggleClass('active');
  });

});
